import React, { useEffect } from 'react'

const Dashboard = (props: any) => {

  useEffect(() => {
    document.title = props.pageTitle;
  })

  return (
    <div>Dashboard</div>
  )
}

export default Dashboard